import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "d-flex justify-end" }

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TileSelect',
  props: {
    tileOptions: {}
  },
  emits: ["submit", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const selectedProposal = ref<number | null>(null);

const handleTile = () => {
  if (!selectedProposal.value) return;
  emits("submit", selectedProposal.value);
  emits("close");
};

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, {
      class: "pa-8",
      width: "500"
    }, {
      default: _withCtx(() => [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mb-6 text-h6" }, "选择平票提案", -1)),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_select, {
            modelValue: selectedProposal.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedProposal).value = $event)),
            items: props.tileOptions,
            "item-title": "label",
            "item-value": "value",
            placeholder: "请选择一个提案",
            density: "comfortable",
            variant: "outlined"
          }, null, 8, ["modelValue", "items"])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            class: "mr-4",
            color: "primary",
            onClick: handleTile
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("确认")
            ])),
            _: 1,
            __: [2]
          }),
          _createVNode(_component_v_btn, {
            color: "red-lighten-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('close')))
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("取消")
            ])),
            _: 1,
            __: [3]
          })
        ])
      ]),
      _: 1,
      __: [4]
    })
  ]))
}
}

})